import { render, staticRenderFns } from "./TenderZonesDialog.vue?vue&type=template&id=93845d5e"
import script from "./TenderZonesDialog.vue?vue&type=script&lang=js"
export * from "./TenderZonesDialog.vue?vue&type=script&lang=js"
import style0 from "./TenderZonesDialog.vue?vue&type=style&index=0&id=93845d5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports